import { render, staticRenderFns } from "./notesSO.vue?vue&type=template&id=9ef48e76&scoped=true"
import script from "./notesSO.vue?vue&type=script&lang=js"
export * from "./notesSO.vue?vue&type=script&lang=js"
import style0 from "./notesSO.vue?vue&type=style&index=0&id=9ef48e76&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef48e76",
  null
  
)

export default component.exports